import { makeAutoObservable } from 'mobx'

interface IAlert {
  type: string
  message: string
}

export class ApiClientStore {

  loader = false
  alert: IAlert = { type: '', message: '' }
  alerting = false

  constructor() { makeAutoObservable(this) }

  showLoader = (show: boolean) => this.loader = show

  showAlert = (alert: IAlert) => {
    this.alerting = true
    this.alert = alert
  }

  clearAlert = () => {
    this.alerting = false
  }
}

export const apiClientStore = new ApiClientStore()
